import React, { useState, useEffect, useRef } from "react";
import Sidebar from '../../composant_reutilisable/sidebar';
import Navbar from "../../composant_reutilisable/navbar";
import useAuth from '../../composant_reutilisable/useAuth';
import { Link, useNavigate } from "react-router-dom";
import TableauDynamique from "../../composant_reutilisable/tableau";
import { FaCheck, FaQuestionCircle, FaTrash, FaUserMinus, FaUserPlus, FaTimes, FaSearch } from "react-icons/fa";
import { Modal, Button } from "react-bootstrap";
import { BsPerson } from "react-icons/bs";
import GlossaireSidebar from '../../composant_reutilisable/glossaireSidebar';
import Footer from "../../composant_reutilisable/footer";
import Pas_acces from "../../composant_reutilisable/pas_acces";
import axios from "axios";

const Liste_utilisateur = () => {
    useAuth();
    const utilisateur_id = localStorage.getItem("utilisateur_id");
    const [isLoading, setIsLoading] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
    const user_id = localStorage.getItem('userId');
    const [alert, setAlert] = useState({ message: '', type: '' });
    const navigate = useNavigate();
    const searchInputRef = useRef(null);

    useEffect(() => {
        if (user_id) {
            document.title = "Transportpro | Utilisateurs";
        }
    }, [user_id]);

    // États
    // const [userData, setUserData] = useState({});
    const [listeUtilisateur, setListeUtilisateur] = useState([]);

    // États pour la recherche et la pagination
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);

    // État pour suivre l'utilisateur sélectionné
    const [utilisateurSelectionne, setUtilisateurSelectionne] = useState(null);


    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
        }, 5000);
    };

    // // Récupérer les données de l'utilisateur
    // useEffect(() => {
    //     const fetchUserData = async () => {
    //         try {
    //             setIsLoading(true);
    //             const response = await fetch(process.env.REACT_APP_HOTE + `/recup-info-profil/${utilisateur_id}/`);
    //             if (response.ok) {
    //                 const data = await response.json();
    //                 setUserData(data);
    //             }
    //             setIsLoading(false);
    //         } catch (error) {
    //             setIsLoading(false);
    //             console.error("Erreur lors de la récupération du profil:", error);
    //         }
    //     };

    //     fetchUserData();
    // }, [utilisateur_id]);


    // Récupérer la liste des utilisateurs
    const fetchUtilisateurs = async () => {
        const token = localStorage.getItem('access_token');
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + "/liste-utilisateurs/",
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                });
            if (response.ok) {
                const data = await response.json();
                setListeUtilisateur(data);
            }
        } catch (error) {
            console.error("Erreur lors de la récupération des utilisateurs:", error);
        }
    };

    useEffect(() => {
        fetchUtilisateurs();
    }, []);

    const colonnesUtilisateurs = [
        //{ titre: "ID", cle: "id" },
        // { titre: "Référence", cle: "reference" },
        { titre: "Nom", cle: "nom" },
        { titre: "Prénoms", cle: "prenoms" },
        { titre: "Email", cle: "email" },
        { titre: "Téléphone", cle: "tel" },
        { titre: "Statut", cle: "statut" },
        // { titre: "Parc affecté", cle: "parc" },
    ];

    // Filtrer les utilisateurs selon le terme de recherche
    const utilisateursFiltres = listeUtilisateur.filter(user =>
        user.nom.toLowerCase().includes(searchTerm.toLowerCase()) ||
        user.prenoms.toLowerCase().includes(searchTerm.toLowerCase()) ||
        user.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
        user.tel.toLowerCase().includes(searchTerm.toLowerCase()) ||
        user.statut.toLowerCase().includes(searchTerm.toLowerCase())
        // user.parc.toLowerCase().includes(searchTerm.toLowerCase())
    );


    // Pagination
    const totalItems = utilisateursFiltres.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const utilisateursAffiches = utilisateursFiltres.slice(indexOfFirstItem, indexOfLastItem);

    const handleSelectionUtilisateur = (user) => {
        // Si on clique sur le même utilisateur → on désélectionne
        if (user) {
            setUtilisateurSelectionne(user);

            // Réinitialiser la sélection des parcs quand on change d'utilisateur
            setParcsSelectionnes([]);
            setParcSearchTerm("");
            setShowDropdown(false);
        } else {
            setUtilisateurSelectionne(null); // désélection
        }
    };


    // Fonction d'activation ou de désactivation des utilisateurs
    const handleActiverDesactiver = async () => {
        const token = localStorage.getItem('access_token');
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/activer-utilisateur/${utilisateurSelectionne.id}/`, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },

            });

            if (response.ok) {

                const data = await response.json(); // On récupère le retour du serveur
                console.log(`Utilisateur ${utilisateurSelectionne.nom} ${data.action} avec succès depuis le serveur.`);
                // Actualisation de la liste complète des utilisateurs
                fetchUtilisateurs();

                // Affichage du message de confirmation
                showAlert(`Utilisateur ${utilisateurSelectionne.nom} ${utilisateurSelectionne.prenoms} ${data.action} avec succès`, "success");

                // Fermer le modal
                setShowModal(false);

                // Réinitialisation de la sélection
                setUtilisateurSelectionne(null);
            } else {
                console.error(`Erreur lors de l'activation/désactivation de ${utilisateurSelectionne.nom}.`);
                showAlert(`Erreur lors de l'activation ou de la désactivation de l'utilisateur ${utilisateurSelectionne.nom}.`, "danger");
            }

        } catch (error) {
            console.error("Erreur serveur :", error);
            showAlert("Erreur serveur lors de l'activation ou de la désactivation de l'utilisateur.", "danger");
        }
    };

    // // Fonction d'activation ou de désactivation des utilisateurs
    // const handlemdp = async () => {
    //     try {
    //         const response = await fetch(`${process.env.REACT_APP_HOTE}/hasher-mots-passe/`, {
    //             method: "POST",

    //         });

    //         if (response.ok) {

    //             const data = await response.json(); // On récupère le retour du serveur
    //             console.log(`mots de passe hasher.`);
    //             // Actualisation de la liste complète des utilisateurs
    //             fetchUtilisateurs();

    //             // Affichage du message de confirmation
    //             showAlert(`mots de passe hasher`, "success");


    //         } else {
    //             console.error(`Erreur lors du hashage `);
    //             showAlert(`Erreur lors de du hashage`, "danger");
    //         }

    //     } catch (error) {
    //         console.error("Erreur serveur :", error);
    //         showAlert("Erreur serveur lors de l'activation ou de la désactivation de l'utilisateur.", "danger");
    //     }
    // };


    // Fonction de suppression
    const handleSupprimer = async () => {
        if (!utilisateurSelectionne) {
            // console.log("❗ Aucun utilisateur sélectionné pour la suppression.");
            return;
        }

        // console.log(`Tentative de suppression de l'utilisateur avec l'ID : ${utilisateurSelectionne.id}`);
        const token = localStorage.getItem('access_token');
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/supprimer-utilisateur/${utilisateurSelectionne.id}/${user_id}/`, {
                method: "DELETE",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });

            if (response.ok) {
                // console.log(`Utilisateur ${utilisateurSelectionne.nom} supprimé avec succès depuis le serveur.`);

                // Mise à jour de la liste des utilisateurs après suppression
                setListeUtilisateur(listeUtilisateur.filter(u => u.id !== utilisateurSelectionne.id));
                // Réinitialisation de la sélection
                setUtilisateurSelectionne(null);
                setShowModal(false);

                // Affichage du message de confirmation
                showAlert(`Utilisateur ${utilisateurSelectionne.nom} ${utilisateurSelectionne.prenoms} supprimé avec succès`, "success");

            } else {
                console.error(`Erreur lors de la suppression de l'utilisateur ${utilisateurSelectionne.nom}.`);
                showAlert(`Erreur lors de la suppression de l'utilisateur ${utilisateurSelectionne.nom}.`, "danger");
            }
        } catch (error) {
            console.error("Erreur réseau lors de la suppression :", error);
            showAlert("Une erreur s'est produite lors de la suppression. Veuillez réessayer.", "danger");
        } finally {
            setShowModal(false);
        }
    };


    const [showModal, setShowModal] = useState(false);
    const [selectedRole, setSelectedRole] = useState(""); // Stocke le rôle sélectionné

    const handleOpenModal = () => {
        if (!utilisateurSelectionne) return;
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedRole(""); // Réinitialiser après fermeture
    };

    // ************************ Affectation d'un utilisateur au parc **********************************

    const [parcs, setParcs] = useState([]); // Liste des parcs récupérée du backend
    const [parcSelectionne, setParcSelectionne] = useState(null); // Le parc choisi dans le modal
    const [showParcModal, setShowParcModal] = useState(false); // Affiche/ferme le modal

    const [parcsSelectionnes, setParcsSelectionnes] = useState([]);
    const [parcSearchTerm, setParcSearchTerm] = useState("");
    const [showDropdown, setShowDropdown] = useState(false);
    const [loadingParcs, setLoadingParcs] = useState(false);

    // const handleOpenParcModal = () => {
    //     if (!utilisateurSelectionne) return;
    //     // fetchParcs();
    //     setShowParcModal(true);
    // };
    // const handleCloseParcModal = () => {
    //     setShowParcModal(false);
    //     setSelectedRole(""); // Réinitialiser après fermeture
    // };
    // Charger les parcs une seule fois
    useEffect(() => {
        const fetchParcs = async () => {
            const token = localStorage.getItem('access_token')
            try {
                const response = await fetch(`${process.env.REACT_APP_HOTE}/liste-parc/`,
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        },
                    });
                if (response.ok) {
                    const data = await response.json();
                    setParcs(data); // sauvegarder les parcs
                }
            } catch (error) {
                console.error("Erreur lors de la récupération des parcs:", error);
            }
        };

        fetchParcs();
    }, []);

    // Fonction pour extraire les parcs actuels de l'utilisateur sélectionné
    const getParcsActuels = () => {
        if (!utilisateurSelectionne) return [];

        const parcValue = utilisateurSelectionne.parc || "";
        if (parcValue === "Non affecté" || !parcValue) return [];

        // Si c'est une chaîne avec plusieurs parcs séparés par des virgules
        if (parcValue.includes(',')) {
            return parcValue.split(',').map(p => p.trim()).filter(p => p);
        }

        // Si c'est un seul parc
        return [parcValue.trim()];
    };

    const handleOpenParcModal = () => {
        if (!utilisateurSelectionne) return;

        // Initialiser la sélection avec les parcs actuels de l'utilisateur
        const parcsActuels = getParcsActuels();
        setParcsSelectionnes(parcsActuels);
        setParcSearchTerm("");
        setShowDropdown(false);
        setShowParcModal(true);

        // Focus sur le champ de recherche après l'ouverture
        setTimeout(() => {
            if (searchInputRef.current) {
                searchInputRef.current.focus();
            }
        }, 300);
    };

    const handleCloseParcModal = () => {
        setShowParcModal(false);
        setParcsSelectionnes([]);
        setParcSearchTerm("");
        setShowDropdown(false);
    };

    // Filtrer les parcs selon le terme de recherche
    const parcsFiltres = parcs.filter(parc =>
        parc.nom_parc?.toLowerCase().includes(parcSearchTerm.toLowerCase()) ||
        parc.ref_parc?.toLowerCase().includes(parcSearchTerm.toLowerCase()) ||
        (parc.type_parc && parc.type_parc.toLowerCase().includes(parcSearchTerm.toLowerCase()))
    );

    // Parcs déjà sélectionnés (pour affichage)
    const parcsSelectionnesDetails = parcs.filter(parc =>
        parcsSelectionnes.includes(parc.ref_parc)
    );

    // Gérer la sélection/désélection d'un parc
    const handleToggleParc = (refParc) => {
        setParcsSelectionnes(prev => {
            if (prev.includes(refParc)) {
                return prev.filter(p => p !== refParc);
            } else {
                return [...prev, refParc];
            }
        });
        // Garder le focus sur le champ
        if (searchInputRef.current) {
            searchInputRef.current.focus();
        }
    };

    // Gérer la touche Entrée pour sélectionner le premier résultat
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && parcsFiltres.length > 0 && showDropdown) {
            e.preventDefault();
            const parc = parcsFiltres[0];
            // Vérifier si le parc est déjà sélectionné
            if (!parcsSelectionnes.includes(parc.ref_parc)) {
                handleToggleParc(parc.ref_parc);
            }
            setParcSearchTerm("");
            setShowDropdown(false);
        }
        if (e.key === 'Escape') {
            setShowDropdown(false);
        }
    };

    // Gérer le clic en dehors du dropdown
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (searchInputRef.current && !searchInputRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);



    // Fonction d'Affectation
    const handleAffecter_obselete = async () => {
        if (!utilisateurSelectionne || !parcSelectionne) {
            console.log("Utilisateur ou parc non sélectionné.");
            return;
        }

        // Retrouver l'objet parc choisi (pour l'affichage du nom)
        const parcChoisi = parcs.find((p) => p.ref_parc === parcSelectionne);

        console.log(
            `Tentative d'affectation de l'utilisateur ID: ${utilisateurSelectionne.id} au parc: ${parcSelectionne}`
        );

        try {
            const response = await fetch(
                `${process.env.REACT_APP_HOTE}/affecter-utilisateur-parc/${user_id}/`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        utilisateur_id: utilisateurSelectionne.id,
                        ref_parc: parcSelectionne, // c'est une string
                    }),
                }
            );

            if (response.ok) {
                console.log(
                    `Utilisateur ${utilisateurSelectionne.nom} affecté au parc ${parcSelectionne} avec succès.`
                );

                showAlert(
                    `Utilisateur ${utilisateurSelectionne.nom} affecté au parc ${parcChoisi?.nom_parc || parcSelectionne}`,
                    "success"
                );

                setShowParcModal(false);
                setParcSelectionne(null);
                fetchUtilisateurs();
            } else {
                console.error(`Erreur lors de l'affectation.`);
                showAlert("Erreur lors de l'affectation.", "danger");
            }
        } catch (error) {
            console.error("Erreur réseau :", error);
            showAlert("Erreur réseau lors de l'affectation", "danger");
        }
    };

    // Fonction d'affectation
    const handleAffecter = async () => {
        if (!utilisateurSelectionne) return;

        const token = localStorage.getItem('access_token');
        try {
            const response = await fetch(
                `${process.env.REACT_APP_HOTE}/affecter-utilisateur-parc/${user_id}/`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        utilisateur_id: utilisateurSelectionne.id,
                        ref_parcs: parcsSelectionnes,
                    }),
                }
            );

            const data = await response.json();

            if (response.ok && data.status === 'success') {
                const nomsParcs = parcsSelectionnes
                    .map(ref => parcs.find(p => p.ref_parc === ref)?.nom_parc || ref)
                    .join(', ');

                showAlert(
                    parcsSelectionnes.length > 0
                        ? `Utilisateur ${utilisateurSelectionne.nom} affecté aux parcs: ${nomsParcs}`
                        : `Utilisateur ${utilisateurSelectionne.nom} désaffecté de tous ses parcs`,
                    "success"
                );

                setShowParcModal(false);
                setParcsSelectionnes([]);
                setParcSearchTerm("");
                setShowDropdown(false);
                fetchUtilisateurs();
            } else {
                showAlert(data.message || "Erreur lors de l'affectation.", "danger");
            }
        } catch (error) {
            console.error("❌ Erreur réseau :", error);
            showAlert("Erreur réseau lors de l'affectation", "danger");
        }
    };


    // ********************************** Fin affectation *********************************************

    // Remplacer parc (réf) par nom_parc
    const utilisateursAvecNomParc = utilisateursFiltres.map(user => {
        if (user.parc && user.parc !== "Non affecté") {
            const parcsRefs = user.parc.split(',').map(p => p.trim());
            const nomsParcs = parcsRefs
                .map(ref => parcs.find(p => p.ref_parc === ref)?.nom_parc || ref)
                .join(', ');
            return {
                ...user,
                parc: nomsParcs || user.parc
            };
        }
        return {
            ...user,
            parc: user.parc || "Non affecté"
        };
    });


    // Fonction de désaffectation
    const handleDesacfecter = async () => {
        if (!utilisateurSelectionne) {
            console.log("❗ Aucun utilisateur sélectionné pour la désaffectation.");
            return;
        }

        // console.log(`📤 Tentative de désaffectation de l'utilisateur avec l'ID : ${utilisateurSelectionne.id}`);

        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/desaffecter-utilisateur-parc/${user_id}/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    utilisateur_id: utilisateurSelectionne.id,
                    // user_id: user_id, // l’admin ou celui qui effectue l’action
                }),
            });

            if (response.ok) {
                // console.log(`✅ Utilisateur ${utilisateurSelectionne.nom} désaffecté avec succès depuis le serveur.`);

                // Mise à jour de la liste des utilisateurs après suppression
                fetchUtilisateurs();
                // Réinitialisation de la sélection
                setUtilisateurSelectionne(null);
                // setShowModal(false);

                // Affichage du message de confirmation
                showAlert(`Utilisateur ${utilisateurSelectionne.nom} ${utilisateurSelectionne.prenoms} désaffecter avec succès`, "success");

            } else {
                console.error(`❌ Erreur lors de la désaffectation de l'utilisateur ${utilisateurSelectionne.nom}.`);
                showAlert(`Erreur lors de la désaffectation de l'utilisateur ${utilisateurSelectionne.nom} ${utilisateurSelectionne.prenoms}.`, "danger");
            }
        } catch (error) {
            console.error("❌ Erreur réseau lors de la désaffectation :", error);
            showAlert("Une erreur s'est produite lors de la désaffectation. Veuillez réessayer.", "danger");
        }
        //  finally {
        //     setShowModal(false);
        // }
    };


    // ********************************** Fin affectation *********************************************

    // // Remplacer parc (réf) par nom_parc
    // const utilisateursAvecNomParc = utilisateursFiltres.map(user => {
    //     const parcTrouve = parcs.find(p => p.ref_parc === user.parc);
    //     return {
    //         ...user,
    //         parc: parcTrouve ? parcTrouve.nom_parc : user.parc // si trouvé affiche nom_parc, sinon garde référence
    //     };
    // });

    const [showGlossary, setShowGlossary] = useState(false);

    const [accesGroupes, setAccesGroupes] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe_id');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe_id');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupes(JSON.parse(accesGroupeStored));
        } else {
            const token = localStorage.getItem('access_token')
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`,
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        },
                    });
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupes(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupes.includes("Utilisateurs")) {
        return (
            <Pas_acces />
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center">
                                    <BsPerson size={25} className='mr-2' /> Utilisateurs
                                </div>

                                {/* Bouton d'aide complètement à droite */}
                                {/* <button
                                    className="btn btn-link p-0 ml-2"
                                    title="Manuel d'utilisation"
                                    onClick={() => navigate('/Manuel-utilisation-admin', {
                                        state: {
                                            fromModule: 'administration',
                                            fromSection: 'utilisateurs'
                                        }
                                    })}
                                >
                                    <FaQuestionCircle size={18} />
                                </button> */}
                                {/* <button
                                    className="btn btn-link p-0 ml-2"
                                    title="Aide"
                                    onClick={() => setShowGlossary(true)}
                                >
                                    <FaQuestionCircle size={18} />
                                </button> */}
                            </h2>
                            <small>Administration des utilisateurs.</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Menu`}> Accueil</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Admin`}> Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item active">
                                        Utilisateurs
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    {alert.message && (
                        <div className={`mt-3 alert alert-${alert.type}`}>
                            {alert.message}
                        </div>
                    )}
                    <div className="wrapper wrapper-content animated fadeInRight mt-3">
                        <div className="">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5>Liste des utilisateurs</h5>
                                <div className="d-flex flex-column flex-md-row">
                                    <button
                                        onClick={handleOpenModal}
                                        disabled={!utilisateurSelectionne}
                                        className={`btn mr-2 mb-2 mb-md-0 ms-0 ms-md-2 ${utilisateurSelectionne ? 'btn-success' : 'btn-default text-dark disabled'}`}
                                    >
                                        <FaTrash /> Supprimer
                                    </button>
                                    <button
                                        onClick={handleActiverDesactiver}
                                        disabled={!utilisateurSelectionne}
                                        className={`btn mr-2 mb-2 mb-md-0 ms-0 ms-md-2 ${utilisateurSelectionne ? 'btn-success' : 'btn-default text-dark disabled'}`}
                                    >
                                        <FaCheck /> Activer/Désactiver
                                    </button>
                                    {/* <button
                                        onClick={handleDesacfecter}
                                        disabled={!utilisateurSelectionne}
                                        className={`btn mr-2 mb-2 mb-md-0 ms-0 ms-md-2 ${utilisateurSelectionne ? 'btn-success' : 'btn-default text-dark disabled'}`}
                                    >
                                        <FaUserMinus /> Désaffecter d'un parc
                                    </button> */}
                                    <button
                                        onClick={handleOpenParcModal}
                                        disabled={!utilisateurSelectionne}
                                        className={`btn mr-2 mb-2 mb-md-0 ms-0 ms-md-2 ${utilisateurSelectionne ? 'btn-success' : 'btn-default text-dark disabled'}`}
                                    >
                                        <FaUserPlus /> Affecter à un parc
                                    </button>
                                </div>
                            </div>
                            <div className="row">

                                <div className="col-lg-12">
                                    <div className="ibox">
                                        <div className="ibox-content">
                                            <TableauDynamique
                                                colonnes={colonnesUtilisateurs}
                                                // donnees={utilisateursAvecNomParc}
                                                donnees={utilisateursFiltres}
                                                isLoading={isLoading}
                                                messageAucun="Aucun utilisateur trouvé."
                                                onSelectRow={handleSelectionUtilisateur}
                                            />
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="footer text-center">
                        <Footer />
                    </div>

                    {/* Modal de confirmation de suppression */}
                    <Modal show={showModal} onHide={handleCloseModal}>
                        <Modal.Header>
                            <Modal.Title>Confirmer la Suppression</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Êtes-vous sûr de vouloir supprimer le compte de <strong>{utilisateurSelectionne?.nom} {utilisateurSelectionne?.prenoms}</strong> ?
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseModal}>
                                <strong>Annuler</strong>

                            </Button>
                            <Button variant="success" onClick={handleSupprimer}>
                                <strong>Supprimer</strong>

                            </Button>
                        </Modal.Footer>
                    </Modal>

                    {/* Modal d'affection */}
                    {/* <Modal show={showParcModal} onHide={handleCloseParcModal}>
                        <Modal.Header>
                            <Modal.Title>Affecter à un parc</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="mb-3">
                                <label htmlFor="parcSelect" className="form-label">
                                    Sélectionnez un parc
                                </label>
                                <select
                                    id="parcSelect"
                                    className="custom-select"
                                    value={parcSelectionne || ""}
                                    onChange={(e) => setParcSelectionne(e.target.value)}
                                >
                                    <option value="">-- Choisir un parc --</option>
                                    {parcs.map((parc) => (
                                        <option key={parc.ref_parc} value={parc.ref_parc}>
                                            {parc.nom_parc} ({parc.ref_parc})
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseParcModal}>
                                <strong>Annuler</strong>
                            </Button>
                            <Button
                                variant="success"
                                onClick={handleAffecter}
                                disabled={!parcSelectionne}
                            >
                                <strong>Affecter</strong>
                            </Button>
                        </Modal.Footer>
                    </Modal> */}


                    {/* Modal d'affectation avec autocomplétion */}
                    <Modal show={showParcModal} onHide={handleCloseParcModal} size="lg">
                        <Modal.Header>
                            <Modal.Title>
                                <FaUserPlus className="mr-2" />
                                Affecter {utilisateurSelectionne?.nom} {utilisateurSelectionne?.prenoms} à un ou plusieurs parcs
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {/* Parcs déjà sélectionnés */}
                            {parcsSelectionnesDetails.length > 0 && (
                                <div className="mb-3">
                                    <label className="font-weight-bold">Parcs sélectionnés :</label>
                                    <div className="d-flex flex-wrap gap-1 mt-1">
                                        {parcsSelectionnesDetails.map(parc => (
                                            <span
                                                key={parc.ref_parc}
                                                className="badge badge-primary d-inline-flex align-items-center p-2 mr-1 mb-1"
                                                style={{ fontSize: '14px', cursor: 'pointer' }}
                                                onClick={() => handleToggleParc(parc.ref_parc)}
                                            >
                                                {parc.nom_parc}
                                                <FaTimes className="ml-1" size={12} />
                                            </span>
                                        ))}
                                    </div>
                                    <small className="text-muted">Cliquez sur un badge pour le retirer</small>
                                </div>
                            )}

                            {parcsSelectionnes.length === 0 && (
                                <div className="mb-3 text-muted">
                                    <small>Aucun parc sélectionné. Tapez dans le champ ci-dessous pour en ajouter.</small>
                                </div>
                            )}

                            {/* Champ de recherche avec autocomplétion */}
                            <div className="mb-3 position-relative" ref={searchInputRef}>
                                <div className="input-group">
                                    <span className="input-group-addon">
                                        <FaSearch />
                                    </span>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Tapez le nom du parc à ajouter..."
                                        value={parcSearchTerm}
                                        onChange={(e) => {
                                            setParcSearchTerm(e.target.value);
                                            setShowDropdown(true);
                                        }}
                                        onFocus={() => setShowDropdown(true)}
                                        onKeyDown={handleKeyDown}
                                        autoComplete="off"
                                    />
                                    {parcSearchTerm && (
                                        <button
                                            className="btn btn-outline-secondary"
                                            type="button"
                                            onClick={() => {
                                                setParcSearchTerm("");
                                                setShowDropdown(false);
                                            }}
                                        >
                                            <FaTimes />
                                        </button>
                                    )}
                                </div>

                                {/* Liste déroulante des suggestions */}
                                {showDropdown && parcSearchTerm && parcsFiltres.length > 0 && (
                                    <div
                                        className="dropdown-menu show w-100"
                                        style={{
                                            maxHeight: '250px',
                                            overflowY: 'auto',
                                            position: 'absolute',
                                            zIndex: 1050
                                        }}
                                    >
                                        {parcsFiltres.map(parc => {
                                            const isSelected = parcsSelectionnes.includes(parc.ref_parc);
                                            return (
                                                <div
                                                    key={parc.ref_parc}
                                                    className={`dropdown-item d-flex justify-content-between align-items-center ${isSelected ? 'bg-light' : ''}`}
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => {
                                                        if (!isSelected) {
                                                            handleToggleParc(parc.ref_parc);
                                                        }
                                                        setParcSearchTerm("");
                                                        setShowDropdown(false);
                                                    }}
                                                >
                                                    <div>
                                                        <strong>{parc.nom_parc}</strong>
                                                        <br />
                                                        <small className="text-muted">{parc.ref_parc}</small>
                                                        {parc.type_parc && (
                                                            <span className="badge badge-light ml-1">{parc.type_parc}</span>
                                                        )}
                                                    </div>
                                                    <div>
                                                        {isSelected ? (
                                                            <span className="badge badge-success">
                                                                <FaCheck /> Sélectionné
                                                            </span>
                                                        ) : (
                                                            <span className="badge badge-primary">
                                                                Ajouter
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                        <div className="dropdown-item text-muted text-center small">
                                            Appuyez sur Entrée pour ajouter le premier résultat
                                        </div>
                                    </div>
                                )}

                                {showDropdown && parcSearchTerm && parcsFiltres.length === 0 && (
                                    <div
                                        className="dropdown-menu show w-100"
                                        style={{
                                            position: 'absolute',
                                            zIndex: 1050
                                        }}
                                    >
                                        <div className="dropdown-item text-muted text-center">
                                            <FaSearch className="mr-2" />
                                            Aucun parc trouvé pour "{parcSearchTerm}"
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* Récapitulatif des sélections */}
                            <div className="mt-2 d-flex justify-content-between align-items-center flex-wrap">
                                <div>
                                    <span className="text-muted">
                                        <strong>{parcsSelectionnes.length}</strong> parc(s) sélectionné(s) au total
                                    </span>
                                </div>
                                <div>
                                    <button
                                        className="btn btn-sm btn-outline-danger mr-2"
                                        onClick={() => setParcsSelectionnes([])}
                                    >
                                        <FaTimes /> Tout retirer
                                    </button>
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseParcModal}>
                                <strong>Annuler</strong>
                            </Button>
                            <Button
                                variant="primary"
                                onClick={handleAffecter}
                            >
                                <FaUserPlus className="mr-2" />
                                <strong>
                                    {parcsSelectionnes.length > 0
                                        ? `Affecter aux ${parcsSelectionnes.length} parc(s)`
                                        : 'Désaffecter tous les parcs'}
                                </strong>
                            </Button>
                        </Modal.Footer>
                    </Modal>



                </div>
            </div>
            <GlossaireSidebar isOpen={showGlossary} onClose={() => setShowGlossary(false)} />
        </div>
    );
};

export default Liste_utilisateur;
